

import React from "react";
import { Card, Typography, Box } from "@mui/material";

const DeviceTestSuccessPopup = ({ onClose }) => (
    <Box
        sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999, // above everything
        }}
    >
        <Card
            sx={{
                p: 4,
                minWidth: 300,
                textAlign: "center",
                borderRadius: 2,
                boxShadow: 3,
            }}
        >
            <Box sx={{ textAlign: "center" }}>
                <img
                    src="/images/succesfull-check.png"
                    alt="Success"
                    style={{ width: 60, height: 60, marginBottom: 16 }}
                />

            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Camera and microphone are working correctly.
            </Typography>
            <button
                className="btn"
                onClick={onClose}
                style={{
                    background: "linear-gradient(135deg, #f79033, #f05a6e)",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    cursor: "pointer",
                    padding: "8px 24px",
                }}
            >
                OK
            </button>
        </Card>
    </Box>
);

export default DeviceTestSuccessPopup;
